import { FC, useCallback } from 'react';
import { Field, FormSpy } from 'react-final-form';
import { useTranslation } from 'react-i18next';
import { FormState } from 'final-form';

import NewSupplementConfirmationControls from '../../NewSupplementConfirmationControls/NewSupplementConfirmationControls';

import SearchAdminSupplements from './SearchAdminSupplements/SearchAdminSupplements';
import { IMatchExistingFormProps, IMatchExistingFormValues } from './MatchExistingForm.interface';

const MatchExistingForm: FC<IMatchExistingFormProps> = ({
  handleSubmit,
  invalid,
  submitting,
  confirmDisabled,
  onSelect,
  onCancel,
}) => {
  const { t } = useTranslation();

  const handleChange = useCallback(
    (props: FormState<IMatchExistingFormValues>) => {
      onSelect(props.values.supplement?.id || null);
    },
    [onSelect],
  );

  return (
    <form onSubmit={handleSubmit} noValidate>
      <Field name="supplement">
        {props => (
          <SearchAdminSupplements
            title={t('adminNewSupplement.searchSupplements')}
            onSelect={props.input.onChange}
          />
        )}
      </Field>

      <FormSpy subscription={{ values: true }} onChange={handleChange} />

      <NewSupplementConfirmationControls
        confirmLabel={t('adminNewSupplement.confirmMatch')}
        confirmDisabled={invalid || confirmDisabled}
        submitting={submitting}
        onCancel={onCancel}
      />
    </form>
  );
};

export default MatchExistingForm;
